import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ButtonList } from '@dixa/lib-shared-habla';
import { Link } from 'react-router-dom';
import { analytics } from 'app/utils/segment';
import { createSearchUrl } from 'app/views/layout/views/search/utils';
const isTransferAllowed = (conversation, profileId) => {
    const { assignment, status, direction, requested_by } = conversation;
    if (!assignment) {
        return true;
    }
    if (['closed', 'pending', 'awaitingpending'].includes(status)) {
        return true;
    }
    return (assignment.agent_id === profileId ||
        (direction === 'internal' && requested_by === profileId) // Internal call started by ourself
    );
};
const ActionsDropdown = ({ csid, userId, profileId, conversation, transferToQueueModalOpen, }) => {
    const searchUrlWithContactFilter = createSearchUrl('conversations', {
        filters: {
            strategy: 'all',
            conditions: [
                {
                    field: 'requested_by',
                    operator: 'is_one',
                    values: [{ label: '', value: userId !== null && userId !== void 0 ? userId : '' }],
                },
            ],
        },
    });
    return (_jsxs(ButtonList, { children: [_jsx(Link, Object.assign({ to: `/conversation/${csid}`, onClick: () => analytics.teamConversationActionsMenuItemClicked({
                    type: 'conversation',
                }) }, { children: _jsx(ButtonList.Item, Object.assign({ icon: "chat" }, { children: "Go to conversation" })) })), isTransferAllowed(conversation, profileId) && (_jsx(ButtonList.Item, Object.assign({ icon: "arrow-right", onClick: (e) => {
                    e.preventDefault();
                    transferToQueueModalOpen(csid);
                    analytics.teamConversationActionsMenuItemClicked({
                        type: 'transferToQueue',
                    });
                } }, { children: "Transfer to queue" }))), _jsx(Link, Object.assign({ to: `/contacts/user/${userId}`, onClick: () => analytics.teamConversationActionsMenuItemClicked({
                    type: 'contact',
                }) }, { children: _jsx(ButtonList.Item, Object.assign({ icon: "id-card" }, { children: "View contact" })) })), _jsx(Link, Object.assign({ to: searchUrlWithContactFilter, onClick: () => analytics.teamConversationActionsMenuItemClicked({
                    type: 'contactConversations',
                }) }, { children: _jsx(ButtonList.Item, Object.assign({ icon: "chat" }, { children: "Conversations with contact" })) }))] }));
};
export default ActionsDropdown;
